var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconRecoverComponent(props, ref) {
  var prefixFromContext = useContext(Context).prefix;
  var _a = props.className,
    className = _a === void 0 ? '' : _a,
    prefixFromProps = props.prefix,
    _b = props.width,
    width = _b === void 0 ? '1em' : _b,
    _c = props.height,
    height = _c === void 0 ? '1em' : _c,
    _d = props.useCurrentColor,
    useCurrentColor = _d === void 0 ? true : _d,
    rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor"]);
  var prefix = prefixFromProps || prefixFromContext || 'arco';
  return /*#__PURE__*/React.createElement("svg", __assign({
    className: "".concat(prefix, "-icon ").concat(prefix, "-icon-Recover ").concat(className),
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    fill: useCurrentColor ? 'currentColor' : '#000',
    xmlns: "http://www.w3.org/2000/svg"
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.97708 13.223C11.8616 12.6268 13.7167 9.80513 13.1206 6.92057C12.5244 4.03601 9.70272 2.18091 6.81816 2.77708C5.70635 3.00686 4.74833 3.56647 4.0239 4.33336H5.8977C6.0818 4.33336 6.23104 4.4826 6.23104 4.6667V5.33336C6.23104 5.51746 6.0818 5.6667 5.8977 5.6667H2.56437C2.19618 5.6667 1.8977 5.36822 1.8977 5.00003V1.6667C1.8977 1.4826 2.04694 1.33337 2.23104 1.33337H2.8977C3.0818 1.33337 3.23104 1.4826 3.23104 1.6667V3.238C4.11358 2.37171 5.24759 1.74017 6.5483 1.47134C10.154 0.726129 13.6811 3.04501 14.4263 6.65071C15.1715 10.2564 12.8526 13.7835 9.24695 14.5287C5.7507 15.2513 2.32834 13.093 1.44441 9.67408C1.39833 9.49585 1.51508 9.31915 1.69537 9.28189L2.34824 9.14695C2.52852 9.10969 2.7039 9.22626 2.75219 9.4039C3.48546 12.1015 6.20218 13.7965 8.97708 13.223Z",
    fillOpacity: "1"
  }));
}
var IconRecover = /*#__PURE__*/React.forwardRef(IconRecoverComponent);
export default IconRecover;